import useRouter from '@gef-ui/router-core/hooks/useRouter';
import PropTypes from 'prop-types';
import React, { Fragment, useRef } from 'react';
import Delegations from '../Delegations';
import Error from '../Error';
import Logout from '../Logout';
import NoAccess from '../NoAccess';
import { includeExcludedUrl } from '../../utils';
import { useDefaultDelegationsValue } from '../utils';
const COMPONENT_NAME = 'InitDelegations';
const defaultWrappers = {
    delegations: Fragment,
    error: Fragment,
    noAccess: Fragment,
    logout: Fragment
};
const InitDelegations = (inProps)=>{
    const { Route, Switch } = useRouter();
    const firstRender = useRef(true);
    const props = useDefaultDelegationsValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { wrappers = defaultWrappers, continueAction, toastrConfig, children, selectors, userInfoEndpointCreators } = props;
    if (includeExcludedUrl(window.location.pathname) && firstRender.current) {
        window.location.href = '/';
        return null;
    }
    firstRender.current = false;
    return /*#__PURE__*/ React.createElement(Switch, null, /*#__PURE__*/ React.createElement(Route, {
        path: "/login/no-access",
        element: /*#__PURE__*/ React.createElement(NoAccess, {
            Wrapper: wrappers.noAccess
        })
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/login/error",
        element: /*#__PURE__*/ React.createElement(Error, {
            Wrapper: wrappers.error,
            toastrConfig: toastrConfig
        })
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/delegations",
        element: /*#__PURE__*/ React.createElement(Delegations, {
            continueAction: continueAction,
            userInfoEndpointCreators: userInfoEndpointCreators,
            selectors: selectors,
            Wrapper: wrappers.delegations
        })
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/logout",
        element: /*#__PURE__*/ React.createElement(Logout, {
            Wrapper: wrappers.logout,
            getIsLogoutFetchLoaded: selectors.getIsLogoutFetchLoaded
        })
    }), children);
};
InitDelegations.propTypes = {
    children: PropTypes.node,
    continueAction: PropTypes.func,
    selectors: PropTypes.shape({
        getIsLogoutFetchLoaded: PropTypes.func,
        getIsOriginalUserFetchLoaded: PropTypes.func
    }),
    toastrConfig: PropTypes.object,
    userInfoEndpointCreators: PropTypes.shape({
        createFetchAction: PropTypes.func,
        createFetchActionWithRepresentedUser: PropTypes.func
    }),
    wrappers: PropTypes.shape({
        delegations: PropTypes.any,
        error: PropTypes.any,
        noAccess: PropTypes.any,
        logout: PropTypes.any
    })
};
export default InitDelegations;
